export default __webpack_public_path__ + "static/media/AgentPhoto.67a9814c.png";